const isDeactivated = (row, usersDeactivated = []) => usersDeactivated.some((id) => id === row.id);

const isReactivated = (row) => {
	if (row.created || row.hasError) return false;
	const fields = row.updatedFields?.updatedFields || [];
	return fields.some((field) => {
		if (field.fieldName !== "Activation Status") return false;
		const value = Array.isArray(field.value) ? field.value[0] : field.value;
		return value === "Active";
	});
};

export const getRowStatusLabel = ({ integrationType, row, usersDeactivated = [] }) => {
	if (row.hasError) {
		if (integrationType === "public-api") {
			return { label: "Failed", color: "red" };
		}
		return { label: "Skipped", color: "yellow" };
	}
	if (row.created) return { label: "Created", color: "green" };
	if (isDeactivated(row, usersDeactivated)) return { label: "Deactivated", color: "orange" };
	if (isReactivated(row)) return { label: "Reactivated", color: "green" };
	if (row.updatesFound) return { label: "Synced", color: "green" };
	return { label: "No Updates", color: "blue" };
};
